import script from "./InformationPanelWordList.component.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationPanelWordList.component.vue?vue&type=script&setup=true&lang=js"

import "./InformationPanelWordList.component.vue?vue&type=style&index=0&id=2a266f67&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a266f67"]])

export default __exports__